import React, { useState, useEffect } from "react";
import { Table, Input, Spin } from "antd";
import "./carlist.scss";
import { FiSearch } from "react-icons/fi";
import { RiEye2Line, RiDeleteBin2Fill, RiEdit2Fill } from "react-icons/ri";
import moment from "moment";
import { FaTags } from "react-icons/fa";
import CustomDeleteModal from "../custom_components/customDeleteModal";
import {
  deleteCarProduct,
  fetchDraftCars,
  fetchUnverifiedCars,
} from "../stores/api_calls/carlists";
import { IconButton } from "../custom_components/customButton";
import CustomProductView from "../custom_components/customProductView";
import { error, success } from "../contants/snackbars";
import { createSearchParams,useNavigate } from "react-router-dom";

const DraftCarLists = () => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState([]);
  const [keywordSearch, setKeywordSearch] = useState("");
  const [showModal, setShowModal] = useState({
    showDelete: false,
    showPreview: false,
    data: {},
  });
  const [tablePagination, setTablePagination] = useState({
    current: 1,
    pageSize: 10,
    total: 30,
    defaultPageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "30"],
  });

  const columns = [
    {
        title: "Date Created",
        dataIndex: "dateCreated",
        render: (text, record) =>
          moment.utc(record.date_created).local().format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: "Car Name",
      dataIndex: "carName",
      // sorter: true,
      render: (text, record) => `${record.product_name}`,
      // width: '20%',
    },
    {
        title: "Car Plate Number",
        dataIndex: "carPlateNumber",
        render: (text, record) => `${record.car_plate_number ?? "Unknown"}`,
    },
    {
      title: "Direct Seller",
      dataIndex: "directSeller",
      render: (text, record) => 
        `${record.advertisement_contact_details?.direct_seller == true ? record.advertisement_contact_details.name : ''}`,
    },
    {
      title: "Advertiser / Dealer",
      dataIndex: "advertiser",
      render: (text, record) => 
        `${record.advertisement_contact_details?.direct_seller == false ? record.advertisement_contact_details?.name : ''}`,
    },
    {
      title: "Product Price",
      dataIndex: "price",
      render: (text, record) => `S$ ${record.product_price.toLocaleString()}`,
    },

    {
      title: "Actions",
      dataIndex: "actions",
      width: "10%",
      render: (text, record) => (
        <div className="actions-icons-container">
          <IconButton
            className="icon-button view"
            tootTipTitle="View Car"
            Icon={<RiEye2Line />}
            onClick={() => onEdit(record)}
          />
          <IconButton
            className="icon-button delete"
            tootTipTitle="Delete Car"
            Icon={<RiDeleteBin2Fill />}
            onClick={() => onDelete(record)}
          />
        </div>
      ),
    },
  ];

  const onEdit = (record) => {
    // const token = Kjur.encode(record);

    navigate(
      {
        pathname: "../cars/edit",
        search: `?${createSearchParams({ id: record._id })}`,
      },
      { replace: true }
    );
  };

  useEffect(() => {
    refetchLists();
  }, []);

  useEffect(() => {
    if (tablePagination.current || tablePagination.pageSize) {
      refetchLists();
    }
  }, [tablePagination.current, tablePagination.pageSize]);

  const refetchLists = () => {
    const pagination = {
      page: tablePagination.current,
      limit: tablePagination.pageSize,
      keyword: keywordSearch,
    };

    fetchData(pagination);
  };

  const fetchData = (data) => {
    setIsLoading(true);

    const soldCars = fetchDraftCars(data);

    soldCars
      .then((res) => {
        if (res.data.success) {
          setTableData(res.data.data);
          setTablePagination({
            ...tablePagination,
            total: res.data.meta.pagination.total,
          });
          setIsLoading(false);
        }
      })
      .catch((e) => {
        error(
          `Opps! ${e.response.data.server_response} . Fetched Failed. Please try again later`
        );
      });
  };

  const onEnter = (e) => {
    if (e.key === "Enter") {
      const pagination = {
        page: 1,
        limit: 10,
        keyword: keywordSearch,
      };
      fetchData(pagination);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTablePagination(pagination);
  };

  const onPreviewProduct = (record) => {
    setShowModal({ ...showModal, showPreview: true, data: record });
  };

  const onDelete = (record) => {
    setShowModal({ ...showModal, showDelete: true, data: record });
  };

  const onDeleteSubmit = () => {
    const filteredData = tableData.filter(
      (el) => el._id !== showModal.data._id
    );

    const onDelete = deleteCarProduct(showModal.data._id);
    onDelete
      .then((res) => {
        if (res.data.success) {
          success("Car deleted successfully.");
          setTableData(filteredData);
          setShowModal({ ...showModal, showDelete: false, data: {} });
        }
      })
      .catch((e) => {
        error(`${e.response.data.server_response}`);
      });
  };

  return (
    <div className="table-container">
      <div className="table-title-icon sold">
        <FaTags />
      </div>
      <p className="table-title-text sold">Draft Car Lists</p>

      <div className="search-container">
        <Input
          size="large"
          style={{ width: 300 }}
          placeholder="Search Record"
          prefix={<FiSearch />}
          onChange={(e) => setKeywordSearch(e.target.value)}
          onKeyPress={onEnter}
        />
      </div>

      <div className='scrollable-table-container'>
        <Table
          columns={columns}
          rowKey={(record) => record._id}
          dataSource={tableData}
          pagination={tablePagination}
          loading={{ indicator: <Spin size="large" />, spinning: isLoading }}
          onChange={handleTableChange}
          bordered
          sticky
        />
      </div>

      <CustomProductView
        title="Product View"
        visible={showModal.showPreview}
        data={showModal.data}
        onCancel={() =>
          setShowModal({ ...showModal, showPreview: false, data: {} })
        }
      />

      <CustomDeleteModal
        title="Delete Car Ad"
        visible={showModal.showDelete}
        onSubmit={onDeleteSubmit}
        onCancel={() =>
          setShowModal({ ...showModal, showDelete: false, data: {} })
        }
        data={{ itemName: `${showModal.data.product_name}`, type: "car ad" }}
      />
    </div>
  );
};

export default DraftCarLists;
